/* Bas du menu mobile : nettoie UNIQUEMENT le selecteur de pays (drapeau) de ses elements invisibles
   (liste deroulante cachee) qui creaient un long defilement dans le vide. Les encarts images
   du menu ne sont jamais touches. Remet aussi en place tout element deplace par l'ancienne version. */
(function () {
  if (window.__mpnDrawerTidy) return; window.__mpnDrawerTidy = true;
  function tidy() {
    var det = document.getElementById('Details-menu-drawer-container');
    if (!det || !det.open) return;
    document.querySelectorAll('#menu-drawer [data-mpn-tidy]').forEach(function (el) {
      if (el.closest('#shopify-section-orbe-header-mobile')) return;
      ['position', 'left', 'right', 'bottom', 'display', 'min-height', 'height'].forEach(function (p) { el.style.removeProperty(p); });
      delete el.dataset.mpnTidy;
    });
    var zone = document.querySelector('#menu-drawer #shopify-section-orbe-header-mobile');
    if (!zone) return;
    zone.querySelectorAll('*').forEach(function (el) {
      if (el.dataset.mpnTidy) return;
      var cs = getComputedStyle(el);
      if (cs.position === 'absolute' || cs.position === 'fixed' || cs.display === 'none') return;
      if (el.offsetHeight < 40) return;
      if (cs.visibility === 'hidden') {
        el.dataset.mpnTidy = '1';
        el.style.setProperty('position', 'absolute', 'important');
        el.style.setProperty('left', '0');
        el.style.setProperty('right', '0');
        el.style.setProperty('bottom', '100%');
      }
    });
  }
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.id === 'Details-menu-drawer-container' && e.target.open) {
      setTimeout(tidy, 400); setTimeout(tidy, 1200);
    }
  }, true);
})();
